<nb-card-header>
    {{title}}
  </nb-card-header>
<nb-list>
    <nb-list-item *ngFor="let key of objectKeys(context)">
        <div class="label">{{ key | titlecase }}</div>
        <div class="value">{{ context[key] }}</div>
    </nb-list-item>
</nb-list>

  
